<template>
  <div>
    <div
      v-if="$apollo.loading"
      class="text-center"
    >
      <BtnComponent loading disabled>&nbsp;</BtnComponent>
    </div>
    <div class="requirements-grid">
      <div
        v-if="unit && filtrationConfiguration"
        class="filtration-clock-box"
      >
        <FiltrationClock
          class="mb-1"
          :filtration-configuration="filtrationConfiguration"
          :filtration-history="filtrationHistory"
          :unit="unit"
        />

        <div class="text-center">
          <DialogComponent v-if="unit?.filtrationHistory?.entries.length > 1">
            <template #activator="{ toggle }">
              <BtnComponent
                outline
                small
                @click="toggle"
              >
                {{ $t('unit.requirements.filtrationHistory') }}
              </BtnComponent>
            </template>
            <template #default>
              <FiltrationHistoryChart
                v-if="unit && filtrationHistory"
                class="mb-1"
                :filtration-history="filtrationHistory"
                :unit="unit"
              />
            </template>
          </DialogComponent>
        </div>
      </div>

      <RequiredValues
        v-if="unit?.requiredValues && unit?.configurationValues"
        :configuration-values="unit.configurationValues"
        :required-values="unit.requiredValues"
        class="req-values"
      />

      <PumpPowerValues
        v-if="unit?.pumpPowerValues"
        :pump-power-values="unit.pumpPowerValues"
        class="pump-power-values"
      />

      <FilterBackwash
        v-if="unit?.backwash"
        :backwash="unit.backwash"
        class="filter-backwash"
      />

      <WaterLevel
        v-if="unit?.waterFilling"
        :water-filling="unit.waterFilling"
        class="water-level"
      />
    </div>
  </div>
</template>

<script>
import FiltrationClock from '@acs/components-library/src/components/deviceDetail/diagrams/FiltrationClock.vue';
import FilterBackwash from '@acs/components-library/src/components/deviceDetail/required/FilterBackwash.vue';
import WaterLevel from '@acs/components-library/src/components/deviceDetail/required/WaterLevel.vue';
import RequiredValues from '@acs/components-library/src/components/deviceDetail/required/RequiredValues.vue';
import PumpPowerValues from '@acs/components-library/src/components/deviceDetail/required/PumpPowerValues.vue';
import FiltrationHistoryChart from '@acs/components-library/src/components/deviceDetail/diagrams/FiltrationHistoryChart.vue';
import DialogComponent from '@acs/components-library/src/components/common/Dialog.vue';

import { ViewQuery } from '@acs/components-library/src/gql/live/UnitDetailRequirements.js';
import BtnComponent from '@acs/components-library/src/components/common/Btn.vue';

export default {
  components: {
    BtnComponent,
    FiltrationClock,
    RequiredValues,
    FilterBackwash,
    WaterLevel,
    FiltrationHistoryChart,
    DialogComponent,
    PumpPowerValues,
  },
  props: {
    sn: {
      type: String,
      required: true,
    },
    unpaired: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  apollo: {
    unitBySerialNumber: {
      query: ViewQuery,
      variables() {
        return {
          sn: this.sn,
        };
      },
      skip() {
        return this.unpaired || !this.sn;
      },
    },
  },
  computed: {
    unit() {
      return this.unitBySerialNumber;
    },
    filtrationConfiguration() {
      return this.unit?.filtrationConfiguration || null;
    },
    filtrationHistory() {
      return this.unit?.filtrationHistory || null;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@acs/components-library/src/assets/styles/variables/sizes.scss';

.requirements-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  .filtration-clock-box {
    padding: 1.5rem 1rem;
    border-radius: .5rem;
    border: 1px var(--boxBorder) solid;
  }
}

@media (min-width: sizes.$tablet) {
  .requirements-grid {
    grid-template-columns: 1fr 1fr;
    .filtration-clock-box {
      order: 1;
      grid-row: span 1;
    }
    .req-values {
      order: 2;
    }
    .pump-power-values {
      order: 3;
    }
    .filter-backwash {
      order: 5;
    }
    .water-level {
      order: 4;
    }

  }
}

</style>
